import { createAction, props } from "@ngrx/store";

import {
  AggregatedMetricsResponse,
  MetricsRequest,
  MetricsResponse,
  TimeSeriesMetric,
} from "./metrics.model";

export const loadMetrics = createAction(
  "[Metrics] Load Metrics",
  props<{ requests: MetricsRequest[] }>()
);

export const loadMetricsRawData = createAction(
  "[Metrics] Load Metrics Raw Data",
  props<{
    regionMetrics: { region: string; metrics: MetricsResponse[] }[];
  }>()
);

export const loadMetricsSuccess = createAction(
  "[Metrics] Load Metrics Success",
  props<{
    metrics: AggregatedMetricsResponse;
    timeSeriesData: TimeSeriesMetric[];
  }>()
);

export const setErrorState = createAction(
  "[Metrics] Set Error State",
  props<{ error: string; failedRegions: string[] }>()
);

export const setUpdatingErrorFlag = createAction(
  "[Metrics] Set Updating Error Flag",
  props<{ updating: boolean }>()
);

export const toggleSelectedProduct = createAction(
  "[Metrics] Toggle Selected Product",
  props<{ product: string }>()
);

export const clearSelectedProducts = createAction(
  "[Metrics] Clear Selected Products"
);

export const selectAllProducts = createAction("[Metrics] Select All Products");

export const toggleSelectedRequestType = createAction(
  "[Metrics] Toggle Selected Request Type",
  props<{ requestType: string }>()
);

export const clearSelectedRequestTypes = createAction(
  "[Metrics] Clear Selected Request Types"
);

export const selectAllRequestTypes = createAction(
  "[Metrics] Select All Request Types"
);

export const setSelectedProducts = createAction(
  "[Metrics] Set Selected Products",
  props<{ products: string[] }>()
);

export const setSelectedRequestTypes = createAction(
  "[Metrics] Set Selected Request Types",
  props<{ requestTypes: string[] }>()
);

export const MetricsActions = {
  loadMetrics,
  loadMetricsRawData,
  loadMetricsSuccess,
  setErrorState,
  setUpdatingErrorFlag,
  toggleSelectedProduct,
  clearSelectedProducts,
  selectAllProducts,
  toggleSelectedRequestType,
  clearSelectedRequestTypes,
  selectAllRequestTypes,
  setSelectedProducts,
  setSelectedRequestTypes,
};
